import React from "react";
import SelectMenu from "../../../controls/SelectMenu";
import {
  convertToDefEventPara,
  productionStatusOptions,
  isFeatureFlag,
} from "../../../../shared/utility";
import NextInProcessModal from "../../../inProcessMonitoring/NextInProcessModal";

export default function ManufacturingRecipeSelect(props) {
  const {
    isEdit,
    manufacturedProduct,
    onFetchRecipeItems,
    recipes,
    handleInputChange,
    inProcessMonitoringHistory,
    updateInProcessMonitoringHistory,
    setEmptyModelOpen,
    previousInProcessMonitoringHistory,
  } = props;

  var chosenRecipe = [];
  if (manufacturedProduct) {
    if (manufacturedProduct.selectedRecipe) {
      if (manufacturedProduct.selectedRecipe.recipe) {
        chosenRecipe = recipes.find(
          (el) => el.value === manufacturedProduct.selectedRecipe.recipe.id
        );
      }
    }
  }

  var currentStatus = null;
  if (manufacturedProduct && manufacturedProduct.status != null) {
    currentStatus =
      productionStatusOptions.find(
        (el) => String(el.value) === String(manufacturedProduct.status)
      ) || null;
  }

  const handleMoveToNext = () => {
    const confirmAction = async (entry, employeePin) => {
      setEmptyModelOpen({ childComponent: null, open: false });

      await updateInProcessMonitoringHistory({
        product_id: manufacturedProduct.product_id,
        production_id: entry.production_id,
        current_history_id: entry.id,
        next_in_process_status_id: entry.next_process_status_id,
        pin: employeePin,
      });
    };

    setEmptyModelOpen({
      open: true,
      childComponent: (
        <NextInProcessModal
          buttonMessage="Move"
          // receive pin from modal and forward both entry and pin to the handler
          confirmAction={(pin) =>
            confirmAction(inProcessMonitoringHistory, pin)
          }
          processRecord={inProcessMonitoringHistory}
          message={`Move ${
            inProcessMonitoringHistory.description_en
              ? inProcessMonitoringHistory.description_en
              : "this product"
          } to next status: ${
            inProcessMonitoringHistory.next_process_status_name
          }?`}
          setOpen={setEmptyModelOpen}
          title="Move to next status"
        />
      ),
    });
  };

  const handleMoveToPrevious = () => {
    const confirmAction = async (entry, employeePin) => {
      setEmptyModelOpen({ childComponent: null, open: false });

      await previousInProcessMonitoringHistory({
        product_id: manufacturedProduct.product_id,
        production_id: entry.production_id,
        current_history_id: entry.id,
        previous_process_status_id: entry.previous_process_status_id,
        pin: employeePin,
      });
    };

    setEmptyModelOpen({
      open: true,
      childComponent: (
        <NextInProcessModal
          buttonMessage="Move"
          // receive pin from modal and forward both entry and pin to the handler
          confirmAction={(pin) =>
            confirmAction(inProcessMonitoringHistory, pin)
          }
          processRecord={inProcessMonitoringHistory}
          message={`Move ${
            inProcessMonitoringHistory.description_en
              ? inProcessMonitoringHistory.description_en
              : "this product"
          } to previous status: ${
            inProcessMonitoringHistory.previous_process_status_name
          }?`}
          setOpen={setEmptyModelOpen}
          title="Move to previous status"
        />
      ),
    });
  };

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 gap-2">
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={(e) => onFetchRecipeItems(e.target.value.value)}
            name="selected_recipe"
            options={recipes}
            defaultValue={isEdit ? chosenRecipe : null}
            title={"Recipe"}
          />
        </div>
        <div className="col-span-1">
          {isFeatureFlag("in_process_monitoring") &&
          inProcessMonitoringHistory ? (
            <div className="bg-white border border-gray-200 rounded-md p-3 text-base">
              <div className="grid grid-cols-1 gap-4">
                <div>
                  <div className="text-sm text-gray-600 font-medium">
                    Current Status
                  </div>

                  <div className="mt-1 ">
                    <button
                      onClick={() => handleMoveToPrevious()}
                      disabled={
                        !inProcessMonitoringHistory.previous_process_status_id
                      }
                      className="mr-2 rounded-md bg-amber-500 px-4 py-2 text-base font-semibold text-white shadow-sm hover:bg-amber-400 filter hover:brightness-110 transition duration-150 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                      {inProcessMonitoringHistory.in_process_status_name}
                    </button>
                  </div>
                </div>

                <div>
                  <div className="text-sm text-gray-600 font-medium">
                    Next Status
                  </div>
                  {inProcessMonitoringHistory.next_process_status_id && (
                    <div className="mt-1">
                      <button
                        onClick={() => handleMoveToNext()}
                        className="mr-2 rounded-md bg-green-500 px-4 py-2 text-base font-semibold text-white shadow-sm hover:bg-green-400 filter hover:brightness-110 transition duration-150 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                      >
                        {inProcessMonitoringHistory.next_process_status_name}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <SelectMenu
              name="status"
              handleInputChange={(e) => {
                handleInputChange(
                  convertToDefEventPara("status", String(e.target.value.value))
                );
              }}
              options={productionStatusOptions}
              defaultValue={isEdit ? currentStatus : null}
              title={"Status"}
            />
          )}
        </div>
      </div>
    </div>
  );
}
